import React, { Component } from 'react';
import { pause, moveRecord, playRecord, addSVG, markInCallSVG } from '../../../Images/CallRecordSVG'
import { resume, noVolume, volume, volumeMedium } from '../../../Images/CallSpaceHeaderSVG'
import { Singleton } from '../../../js/Singleton';
import ReactSimpleRange from 'react-simple-range';
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle.js';
import { PlayerFactory } from 'global-audio-player-js/global-audio-player-js-bundle.min.js';
import { TYPE_MARKS } from '../../../constants'
import { SingletonSharedData } from '../../../js/singletonSharedData';
import { manualCallWindow } from '../../../js/draggableComponents';
import { secondsToFormat } from '../../../js/helpers/Utils/formats'
import { recordingNotFound, configurationErrorBody } from '../../../js/alertBodies';
import AlertWindow from '../Others/AlertWindow.jsx';
import { Logger } from '../../../js/helpers/Logger';

export default class PlayerReproductor extends Component {
  constructor(props) {
    super(props);
    this.language = new Singleton();
    this.state = {
      currentTimeRecord: 0,
      recordLength: 0.1,
      playerIsPlaying: false,
      tableData: [],
      callSpeed: 1,
      currentSpeed: 1000,
      currentVolume: 100,
      volumeShowed: false,
      recordingNotFound: false,
      configurationError: false,
      listMarks: [],
      audioLoaded: false,
    };
    this.sharedData = new SingletonSharedData();
    let APIFact = new APIFactory();
    this.apiCont = APIFact.buildClient();
    this.callObj = { "userId": 0, "calId": 0, "type": "", "times": "" };
    this.callMarks = "";
    this.path = "";
    this.skipLength = 2.0;
    this.isIE = false;
    this.resize = this.resize.bind(this)
  }
  componentDidMount() {
    this.isIE = false || !!document.documentMode;
    Logger.Trace(`[Player Reproductor][componentDidMount] Internet Explorer ${this.isIE}`);
    window.addEventListener('resize', this.resize);
    if (!this.isIE) {
      let plFactory = new PlayerFactory();
      this.audioPlayer = plFactory.buildClient('#waveform');
    }
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
    this.saveMarks();
    this.pausePlayer();
    this.cleanPath("");
  }
  openManualCall(selected) {
    let objProps = {
      campaingName: selected.original.campaing,
      campaingID: selected.original.idCampaing,
      phoneNumber: selected.original.phoneNumber
    }
    this.props.insertWindow(manualCallWindow(objProps), false);
  }
  resize() {
    let currentList = this.state.listMarks;
    this.setState({
      listMarks: currentList.map((item) => {
        return {
          time: item.time,
          duration: item.duration,
          position: (item.time.split(':').reduce((acc, time) => (60 * acc) + +time)) * this.getReproductionBarSize() / Math.round(item.duration),
          type: TYPE_MARKS.AGENT,
        }
      })
    });
  }
  movingRecordCall(props) {
    this.setState({ currentTimeRecord: props.value, callSpeed: 1, playerIsPlaying: true });
    this.audioPlayer.playRecording(props.value);
    this.setTimer(1);
  }
  volumecontrol(props) {
    this.setState({ currentVolume: props.value });
    this.audioPlayer.setVolume(props.value / 100.0);
  }
  addMark = () => {
    this.callMarks += ('|' + secondsToFormat(this.state.currentTimeRecord, true));
    let currentList = this.state.listMarks;
    let validation = false;
    let newMark = {
      position: (this.state.currentTimeRecord * this.getReproductionBarSize() / this.state.recordLength),
      type: TYPE_MARKS.AGENT,
      time: secondsToFormat(this.state.currentTimeRecord, true),
      duration: this.state.recordLength,
    }
    for (let { time } of currentList) {
      if (time === newMark.time)
        validation = true;
    }
    if (!validation) {
      currentList.push(newMark);
      this.setState({ listMarks: currentList });
    }
  }

  setCallObject(callObject) {
    this.callObj = callObject;
  }
  saveMarks() {
    this.callObj.times = this.callMarks.slice(1);
    if (this.callMarks) {
      this.apiCont.markCall(this.callObj, this.apiCont.getObjectResponse());
      this.callMarks = "";
    }
  }
  initLoading() {
    this.setState({ audioLoaded: false, listMarks: [] });
  }
  loadPath(path, marks) {
    try {
      var url = window.location.href;
      this.validatePath(path);
      this.validateUrlandBasePathSecurity(url, path);
      let _this = this;
      this.audioPlayer.loadRecording(path).then((duration) => {
        _this.setState({
          recordLength: Math.round(duration),
          currentTimeRecord: 0,
          playerIsPlaying: false,
          recordingNotFound: false,
          configurationError: false,
          audioLoaded: true,
          listMarks: marks.map((item) => { return { position: (item.split(':').reduce((acc, time) => (60 * acc) + +time)) * this.getReproductionBarSize() / Math.round(duration), type: TYPE_MARKS.AGENT, time: item, duration: duration } })
        })
        this.path = path;
        clearInterval(this.timerPlayer);
      })

    }
    catch (error) {
      Logger.Trace(error);
      this.handleErrorOnAudio(error);
      this.cleanPath();
    }
  }
  validatePath(path) {
    if (!path) {
      var error = new Error("Path is empty; No recording found");
      error.code = "REC_NOT_FOUND";
      throw error;
    }
  }
  validateUrlandBasePathSecurity(url, databasePath) {
    var urlSecurity = url.split(":")[0];
    var databasePathSecurity = databasePath.split(":")[0];
    if (urlSecurity !== databasePathSecurity) {
      var error = new Error("Security configuration of Url and database Path are different")
      error.code = "CONFIG_ERROR";
      throw error;
    }
  }
  handleErrorOnAudio(error) {
    error.code === "CONFIG_ERROR" ? this.databaseConfigurationError() : this.recordNotFoundError();
  }
  getReproductionBarSize() {
    if (window.innerWidth < 640) {
      return 146;
    }
    else {
      return 232;
    }
  }
  recordNotFoundError() {
    let _this = this;
    this.setState({ recordingNotFound: true })
    this.setState({ configurationError: false });
    setTimeout(function () { _this.setState({ recordingNotFound: false, configurationError: false }) }, 4000);
  }
  databaseConfigurationError() {
    let _this = this;
    this.setState({ recordingNotFound: true });
    this.setState({ configurationError: true });
    setTimeout(function () { _this.setState({ recordingNotFound: false, configurationError: false }) }, 6000);
  }
  cleanPath() {
    this.path = "";
    this.setState({
      recordLength: 0.1,
      currentTimeRecord: 0,
      playerIsPlaying: false
    });
    clearInterval(this.timerPlayer);
    if (this.audioPlayer) {
      this.audioPlayer.stopRecording();
    }

    this.initLoading();
  }
  pausePlayer() {
    if (this.state.playerIsPlaying) {
      this.setState({ playerIsPlaying: false, callSpeed: 1 });
      this.audioPlayer.playPauseRecording();
      clearInterval(this.timerPlayer);
      this.audioPlayer.speed(1);
    }
  }
  backwardRecording = () => {
    this.audioPlayer.backwardRecording();
    let backward = this.state.currentTimeRecord - this.skipLength < 0 ? 0 : this.state.currentTimeRecord - this.skipLength;
    this.setState({ currentTimeRecord: backward });
  }
  forwardRecording = () => {
    if (this.state.currentTimeRecord > 0 && (this.state.currentTimeRecord + (this.skipLength * this.state.callSpeed) < this.state.recordLength)) {
      this.audioPlayer.forwardRecording();
      let forward = this.state.currentTimeRecord + this.skipLength >= this.state.recordLength ? 0 : this.state.currentTimeRecord + this.skipLength;
      this.setState({ currentTimeRecord: forward });
    }
  }
  playRecord = () => {
    this.setState({ playerIsPlaying: !this.state.playerIsPlaying, callSpeed: 1 });
    this.audioPlayer.playPauseRecording();
    clearInterval(this.timerPlayer);
    this.audioPlayer.speed(1);
    if (!this.state.playerIsPlaying) {
      this.setTimer(1);
    }
  }
  setTimer(speed) {
    clearInterval(this.timerPlayer);
    var _this = this;
    this.timerPlayer = setInterval(playerMethod, 1000 / speed);
    function playerMethod() {
      _this.setState({
        currentTimeRecord: _this.state.currentTimeRecord + 1
      });
      if (_this.state.currentTimeRecord >= _this.state.recordLength) {
        _this.setState({
          currentTimeRecord: 0,
          playerIsPlaying: false,
        });
        _this.audioPlayer.speed(1);
        clearInterval(_this.timerPlayer);
      }
    }
  }
  setCallSpeed = () => {
    var currentSpeed = (this.state.callSpeed + 0.5) > 2.0 ? 1 : this.state.callSpeed + 0.5;
    this.setState({ callSpeed: currentSpeed });
    this.audioPlayer.speed(currentSpeed);
    this.setTimer(currentSpeed);
  }
  onClickBtnVolumen = () => {
    this.setState({ volumeShowed: !this.state.volumeShowed });
  }

  
  componentDidUpdate(prevProps){
    if(prevProps.disabled !== this.props.disabled && this.props.disabled){
      this.setState({volumeShowed: false});
    }
  }

  validateMarksPermission(){
    return this.sharedData.getAllowMarksPermission();
  }

  render() {
    return (
      <div className="playerRecordCall">
        <div id="waveform" className="audioPlayerWaves"></div>
        <div className="controlsContainer">
          <div className={"iconMoveRecord " + (this.state.audioLoaded && !this.props.disabled ? "" : "disabled")} onClick={this.props.disabled ? undefined : this.backwardRecording}>{moveRecord}</div>
          <div className={"iconPlayRecord " + (this.state.audioLoaded && !this.props.disabled ? "" : "disabled")} onClick={this.props.disabled ? undefined : this.playRecord}>{(this.state.playerIsPlaying && this.state.recordLength >= 1 ? pause : playRecord)}</div>
          <div className={"iconMoveRecord fordward " + (this.state.audioLoaded && !this.props.disabled ? "" : "disabled")} onClick={this.props.disabled ? undefined : this.forwardRecording} >{moveRecord}</div>
        </div>
        <div className="playerContainer">
          {!this.isIE &&
            <div className="playerCall">
              <ReactSimpleRange
                value={this.state.currentTimeRecord}
                min={0}
                max={this.state.recordLength}
                sliderSize={3}
                sliderColor="rgba(255,255,255,0.22)"
                trackColor="#17A2FF"
                verticalSliderHeight="100%"
                onChange={this.movingRecordCall.bind(this)}>
                <div className="thumbCustomPlayer"></div>
              </ReactSimpleRange>
            </div>
          }
          {this.state.listMarks.map((item) =>
            <div className={"markInCall " + item.type} key={item.position} style={{ left: (item.position - 2) }}>
              {markInCallSVG}
            </div>)};
          <p className="timePlayer beginTime">{secondsToFormat(this.state.currentTimeRecord, false)}</p>
          <p className="timePlayer endTime">{secondsToFormat(this.state.recordLength, false)}</p>
        </div>
        <p className={"playerSpeed " + (this.state.audioLoaded && this.state.playerIsPlaying ? "" : "disabled")}
          onClick={this.props.disabled ? undefined : this.setCallSpeed}>{this.state.callSpeed + "x"}</p>
        <div className={`volumeContainerRecord ${this.props.disabled ? 'disabled' : ''}`}>
          {this.state.volumeShowed &&
            <div className="sliderContainer" >
              <ReactSimpleRange
                vertical
                value={this.state.currentVolume}
                sliderSize={3}
                sliderColor="rgba(255,255,255,0.22)"
                trackColor="blue"
                thumbColor="#B71C1C"
                verticalSliderHeight="80%"
                onChange={this.volumecontrol.bind(this)}>
                <div className="thumbCustom"></div>
              </ReactSimpleRange>
            </div>}
          <div className={"volumeButton " + (this.state.volumeShowed ? "active " : "") + (this.state.audioLoaded ? "" : "disabled")}
            onClick={this.props.disabled ? undefined : this.onClickBtnVolumen}>
            {this.state.currentVolume === 0.0 ? noVolume : this.state.currentVolume > 0.5 ? volume : volumeMedium}
          </div>
        </div>
        <div className={"btnAddMark " + (this.state.audioLoaded && !this.props.disabled && this.validateMarksPermission() ? "" : "disabled")} onClick={this.props.disabled ? undefined : this.addMark}>
          <div className="container100">{resume}</div>
          <div className="container100">{addSVG}</div>
        </div>
        {this.state.recordingNotFound &&
          <div className="alertContainerDisappear">
            <AlertWindow
              title={this.state.configurationError ? this.language.getText("GUIAlertMessageconfigurationError") : this.language.getText("GUIAlertMessagenotFound")}
              body={this.state.configurationError ? configurationErrorBody() : recordingNotFound()}
              isGlobe={true} />
          </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/workSpace/Others/PlayerReproductor.jsx